module.exports = __webpack_public_path__ + "img/erin-patterson.672dc62d.png";